import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  width: 100%;
  height: 274px;
`

export const Label = styled.p`
  width: 100%;
  color: ${colors.mainText};
`

export const FieldContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 16px 0;
  width: 100%;
`

export const InputField = styled.input`
  width: 100%;
  padding: 12px 16px;
  height: 48px !important;
  border: 1px solid ${colors.greyStroke};
  border-radius: 8px;
`

export const Placeholder = styled.span`
  position: absolute;
  top: -7px;
  left: 8px;
  padding: 0 4px;
  font-size: 10px;
  color: ${colors.greyTextWhiteBg};
  background-color: ${colors.white};
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 24px 0;
`

export const ErrorMessage = styled.span`
  margin-top: 8px;
  width: 100%;
  color: ${colors.messegesRed};
  font-size: 14px;
`

export const Button = styled.div``

export const AlertText = styled.div`
  margin-bottom: 9px;
  display: flex;
  flex-direction: column;
`
export const AlertTitle = styled.div`
  font-weight: 600;
`

export const MeetConditionsBtn = styled.a`
  color: ${colors.messegesYellow1} !important;
  border-bottom: 1px dashed ${colors.messegesYellow1};
  text-decoration: none;
  text-align: center;
  margin-left: 5px;
  margin-top: 17.5px;

  &:hover {
    color: ${colors.messegesYellow1};
  }
`

export const AlertWrapper = styled.div`
  display: flex;
  align-items: center;
`
